<template>
  <svg :class="`check-icon ${checked ? 'check-icon--checked' : ''}`" viewBox="0 0 26 20" fill="none">
    <path d="M3 10.625L7.875 16.25L22.875 3.875" :stroke="backgroundColor" :stroke-width="strokeWidth * 2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M3 10.625L7.875 16.25L22.875 3.875" :stroke="color" :stroke-width="strokeWidth" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<script>
export default {
  name: 'check-icon',
  props: {
    checked: Boolean,
    strokeWidth: {
      type: Number,
      default: 3
    },
    backgroundColor: {
      type: String,
      default: 'white'
    },
    color: {
      type: String,
      default: '#9A34FF'
    }
  }
}
</script>

<style lang="scss" scoped>
.check-icon {
  z-index: 100;
  stroke-dasharray: 27;
  stroke-dashoffset: 27;

  &--checked > path {
    animation-duration: 120ms;
    animation-fill-mode: forwards;
    animation-timing-function: cubic-bezier(.72,.01,.83,.83);
    animation-name: fill-checkmark;
  }
}

@keyframes fill-checkmark {
  from { stroke-dashoffset: 27; }
  to { stroke-dashoffset: 0; }
}
</style>
